import React from 'react';
import { FixedSizeList, areEqual } from 'react-window';
import { DragDropContext, Droppable, Draggable,DropResult } from 'react-beautiful-dnd';
import {FishProfileSingle} from './fruit-profile-single';
import useWindowSize from 'src/hook/use-window-size';

import { useHarvestingContext } from 'src/views/harvesting/harvesting-context';
import { usePreferenceContext } from 'src/context/PreferenceContext';
import {
  DisplayNoFishesTemplate,
  TalkToFishingTemplate,
  TimeToReportFishesTemplate,
  LetsFishingTemplate,
  LuckyNoFilteredTemplate
} from './components/display-results';


interface RowType {
  data:any
  index:number
  style:any
}
const Row = React.memo<RowType>(function Row({data:items, index, style }) {
  const item = items[index];
   
  return (
    <Draggable draggableId={item.id} index={index} key={item.id} isDragDisabled={true}>
      {(provided) => (
        //TODO: DOUBLE CHECK THIS LOGIC
        <FishProfileSingle provided={provided} fruit={item} style={style}/>
      )}
    </Draggable> 
  );
}, areEqual);

export const FruitProfilDndParents:React.FC =()=> {
  const {
    getFruitsBystatus,
    allCount,
    availableCount,
    filteredCount,
    textedCount,
    reorderBasket,
  } = useHarvestingContext();

  const { fruitsTab } = usePreferenceContext();

  const getFruitsByTab = getFruitsBystatus(fruitsTab);
  const windowSize = useWindowSize();
  function onDragEnd(result: DropResult) {
    if (!result.destination) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }
    reorderBasket(result.source.index, result.destination.index);
  }

  // eslint-disable-next-line no-constant-condition
  if (getFruitsByTab.length === 0) {
    //CURRENT LIST HAS NO FRUITS

    //WHEN THERE ARE NOT FISH LIST IMPORTED
    if (allCount === 0) {
      return <LetsFishingTemplate />;
    }
    //FISH LIST IMPORTED BUT THERE ARE 0 AVAIALBE FISHES
    if (allCount !== 0 && availableCount === 0 && textedCount === 0) {
      return <DisplayNoFishesTemplate />;
    }
    //YOU TEXTED SOMEONE AND NO MORE AVAILABLE FISHES
    if (textedCount > 0 && availableCount === 0) {
      return <TimeToReportFishesTemplate />;
    }
    //YOU HAVEN'T TEXTED ANYONE YET
    if (textedCount === 0) {
      return <TalkToFishingTemplate />;
    }
    //YOU TEXTED SOMEONE AND NO MORE AVAILABLE FISHES
    if (fruitsTab ==='Filtered' && filteredCount === 0) {
      return <LuckyNoFilteredTemplate />;
    }
  }
  

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd} >

        <Droppable
          droppableId="droppable"
          mode="virtual"
          renderClone={(provided, snapshot, rubric) => (
            <FishProfileSingle
              provided={provided}
              isDragging={snapshot.isDragging}
              fruit={getFruitsByTab[rubric.source.index]}
            />
          )}
        >
          {(provided) => (
            <FixedSizeList
              height={windowSize.height - 277}
              itemCount={getFruitsByTab.length}
              itemSize={96}
              width={'100%'}
              outerRef={provided.innerRef}
              itemData={getFruitsByTab}
            >
              {Row}
            </FixedSizeList>
          )}
        </Droppable>
   
      </DragDropContext>
    </>
  );
};
